import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/lib/dateLocale";
import App from "@/App";

// Benign browser warning (Radix popovers inside dialogs) — keep it out of the dev overlay.
window.addEventListener("error", (e) => {
  if (e.message?.includes("ResizeObserver loop")) e.stopImmediatePropagation();
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
